import React from 'react'
import { observer } from '~/common/mobx.decorator'
import { CareLayout } from './care.layout'
import { CareRoute } from './care.route'
import { careStore } from './care.store'
import { Helmet } from 'react-helmet'
import { appStore } from '~/stores'
import { useTranslation } from '@opus/web.core.hooks.use-translation'

export const CareCompany = observer(() => {
	const { t } = useTranslation()
	const { name, useLayout } = careStore.getActiveFeature() || {}

	const title = React.useMemo(
		() => (name ? `${t(name)} | ${appStore.name}` : appStore.name),
		// eslint-disable-next-line
		[name, appStore.name]
	)

	return (
		<>
			<Helmet>
				<title>{title}</title>
			</Helmet>
			{useLayout === false ? (
				<CareRoute />
			) : (
				<CareLayout>
					<CareRoute />
				</CareLayout>
			)}
		</>
	)
})
